import { getStore } from '../store/store';

export function getTotalGetStartedTaskCount(): number {
    const store = getStore();

    if (store.tasks) {
        return Object.keys(store.tasks).length;
    }

    return 0;
}
